import React from 'react';
import {connect} from 'react-redux';
import {BaseUsedTeams} from 'components/organisms/used-teams/components/sports/lol';
import {calcPercentage} from 'helpers/common-helper';

class UsedTeamsComponent extends BaseUsedTeams {
    render() {
        let {lineups} = this.props;
        lineups = lineups.all();

        let teamList = this.groupTeamUsage(lineups);
        teamList = this.prepareTeams(teamList);

        let countLineups = Object.keys(lineups).length;
        let usedTeams = [];

        if (countLineups > 0) {
            Object.values(teamList).map((team, index) => {
                const percentage = calcPercentage(countLineups, team.usedLineupsCount);
                const className = index % 2 === 0 ? 'even' : '';

                usedTeams.push(
                    <tr key={index} className={className}>
                        <td>
                            <strong>{team.name}</strong>
                        </td>
                        <td className="text-blue">
                            {percentage}% ({team.usedLineupsCount})
                        </td>
                    </tr>,
                );
            });
        } else {
            usedTeams.push(this.getNotFoundView());
        }

        return (
            <div className="players-used-table table-holder">
                <div className="table-scroll">
                    <table className="table">
                        <thead>
                            <tr>
                                <th>Team</th>
                                <th>Exp%</th>
                            </tr>
                        </thead>
                        <tbody>{usedTeams}</tbody>
                    </table>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {lineups} = state.lineupsData;
    return {
        lineups,
    };
}

let UsedTeams = connect(mapStatesToProps)(UsedTeamsComponent);

export {UsedTeams};
